var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import ReactSelect from "react-select";
import CreatableSelect from "react-select/creatable";
import { useTranslation } from "./hooks/useTranslation";
export var bootstrapStyle = {
    control: function (styles) { return (__assign(__assign({}, styles), { minHeight: "34px", transition: "none" })); },
    clearIndicator: function (styles) { return (__assign(__assign({}, styles), { padding: "2px 8px" })); },
    dropdownIndicator: function (styles) { return (__assign(__assign({}, styles), { padding: "2px 8px" })); },
    loadingIndicator: function (styles) { return (__assign(__assign({}, styles), { padding: "2px 8px" })); },
    menu: function (styles) { return (__assign(__assign({}, styles), { zIndex: 3 })); },
    noOptionsMessage: function (styles) { return (__assign(__assign({}, styles), { 
        // react-select defaults this notice to hsl(0, 0%, 60%), which is about
        // 2.9:1 on white and fails WCAG AA. The notice carries real explanations
        // and not just placeholder hints, so it uses the body text colour
        // ($text-color) instead.
        color: "#435969" })); },
    option: function (styles) { return (__assign(__assign({}, styles), { minHeight: "29px", height: "inherit" })); },
};
/**
 * Presentational select: react-select with piston styling and no form
 * system attached. Fully controlled through `value`/`onChange`, so it can
 * be wired to any form library (e.g. react-hook-form) or used standalone.
 */
export var BaseSelect = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, components = _a.components, _b = _a.multiple, multiple = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.autoFocus, autoFocus = _d === void 0 ? false : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, _f = _a.formatter, formatter = _f === void 0 ? function (option) { return option.label; } : _f, placeholder = _a.placeholder, _g = _a.isClearable, isClearable = _g === void 0 ? true : _g, ariaLabelledby = _a.ariaLabelledby, ariaLabel = _a.ariaLabel, id = _a.id, _h = _a.creatable, creatable = _h === void 0 ? false : _h, menuPortalTarget = _a.menuPortalTarget, dataId = _a.dataId, dataTestId = _a.dataTestId;
    var t = useTranslation();
    if (placeholder === undefined) {
        placeholder = "".concat(t("Select"), "...");
    }
    var Component = creatable
        ? CreatableSelect
        : ReactSelect;
    return (React.createElement(Component, __assign({ "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, id: id, components: components, styles: bootstrapStyle, isMulti: multiple, options: options, value: value, onChange: onChange, onBlur: onBlur, isClearable: isClearable, getOptionValue: JSON.stringify, getOptionLabel: formatter, className: "react-select", isDisabled: disabled || loading, classNamePrefix: "select", autoFocus: autoFocus, isLoading: loading, placeholder: placeholder, menuPortalTarget: menuPortalTarget, "data-id": dataId, "data-testid": dataTestId }, (creatable ? { noOptionsMessage: function () { return null; } } : {}))));
};
